import * as React from "react";
import {  useEffect, useState } from "react";
import { CustomError } from "../Models/CustomError";
import Axios from "axios";
import { RouteComponentProps } from "react-router-dom";
import { Formik } from "formik";
import { Note as NoteModel } from "../Models/Note";
import { CreateNoteValildationErrors } from "../Models/CreateNoteValidationErrors";
import { MultiSelect } from "react-multi-select-component";
import { Tag } from "../Models/Tag";
import { Options } from "../Models/Options";
import {EditNote as EditNoteModel} from "../Models/EditNote";
import { isCustomError } from "../Utils";

interface IProps extends RouteComponentProps {}

export const Note = (props: IProps): JSX.Element => {
    const [postErrors, setPostErrors] = useState<CustomError>();
    const { history } = props;

    const [tagArr, setTagArr] = useState<Tag[]>([]);
    const [selectedTags, setSelectedTags] = useState<Options[]>([]);

    
    const onCancel = (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    ) => {
        event?.preventDefault();
        history.push("/");
    };

    useEffect(()=>{
        async function getTags() {
            try {
                const response = await Axios.get(
                    `${process.env.REACT_APP_API_URL}/api/v1/tags`
                );
                const tags = response.data as Tag[];
                setTagArr(tags);
            } catch (error) {
                if(isCustomError(error)){
                    setPostErrors(error);
                }
            }
        }
        getTags();
    },[setTagArr]);

    return (
        <Formik
            initialValues={{ title: "", post: "", tags:[] }}
            validate={(values: NoteModel) => {
                const errors: CreateNoteValildationErrors = {
                    post: "",
                    title: "",
                };
                if (!values.title) {
                    errors.title = "Required";
                }
                if (!values.post) {
                    errors.post = "Required";
                }
                if (
                    errors.title !== "" ||
                    errors.post !== ""
                ) {
                    return errors;
                }
                return {};
            }}
            onSubmit={async (values: NoteModel, { setSubmitting }) => {
                console.log(values);
                //save new note
                let editNote: EditNoteModel = { 
                    post: values.post,
                    title: values.title,
                    tagIds: selectedTags?.map(tag => tag.value),
                };

                //save new note
                try {
                    await Axios.post(process.env.REACT_APP_API_URL + "/api/v1/notes", editNote);
                    history.push("/");
                } catch (error) {
                    if(isCustomError(error)){
                        setPostErrors(error);
                    }
                }

                setSubmitting(false);
            }}
        >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
            }) => (
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label>Title:</label>
                        <input
                            type="text"
                            className="form-control"
                            id="title"
                            name="title"
                            onChange={handleChange("title")}
                            value={values.title}
                            onBlur={handleBlur}
                        />
                        {touched.title && (
                            <span className="text-muted">{errors.title}</span>
                        )}
                    </div>

                    <div className="form-group">
                        <label>Tags:</label>

                        <MultiSelect
                            options={tagArr.map((tag: Tag) => {
                                return { label: tag.name, value: tag.id };
                            })}
                            value={selectedTags}
                            labelledBy={"Select"}
                            onChange={setSelectedTags}
                        />
                    </div>

                    <div className="form-group">
                        <label>Post:</label>
                        <textarea
                            className="form-control"
                            id="post"
                            name="post"
                            onChange={handleChange("post")}
                            value={values.post}
                            onBlur={handleBlur}
                        />
                        {touched.post && (
                            <span className="text-muted">{errors.post}</span>
                        )}
                    </div>

                    <button
                        className="btn btn-primary"
                        type="submit"
                        disabled={isSubmitting}
                    >
                        Save
                    </button>
                    <button className="btn btn-primary" onClick={onCancel}>
                        Cancel
                    </button>

                    {postErrors?.errors.map((error: string) => (
                        <small className="form-text text-muted">{error}</small>
                    ))}
                </form>
            )}
        </Formik>
    );
};
